/**
 * Error tracking (PRD Bagian 11 [Wajib]; error-handling.md "dipasang CP12/13").
 *
 * Keputusan CP12: SDK Sentry dimuat **dinamis** hanya bila `VITE_SENTRY_DSN`
 * terisi — DSN kosong (default dev/.env.example) → tidak ada import, tidak
 * ada request keluar, tidak menambah bundle awal (chunk terpisah). Alarm proxy
 * gagal berulang disediakan worker `/healthz` (`workers/bmkg-proxy/src/health.ts`);
 * penghubung uptime checker eksternal diserap RUNBOOK CP15.
 */
import { clientEnv } from '../config';

/** DSN aktif? Murni — kosong = nonaktif (jujur, bukan sukses palsu). */
export function errorReportingConfigured(): boolean {
  return clientEnv('VITE_SENTRY_DSN').trim().length > 0;
}

export type ErrorReporter = { captureMessage: (message: string) => void };

let active: ErrorReporter | null = null;

/** Siapa yang menampung error kini (null bila tidak dikonfigurasi). */
export function currentErrorReporter(): ErrorReporter | null {
  return active;
}

/** Inisialisasi error tracking; aman dipanggil saat DSN kosong (no-op jujur). */
export async function initErrorReporting(): Promise<void> {
  if (active !== null) return;
  const dsn = clientEnv('VITE_SENTRY_DSN').trim();
  if (dsn.length === 0) return;
  const Sentry = await import('@sentry/react');
  // Browser SDK tidak mengirim data pribadi secara bawaan (privacy default),
  // jadi tidak ada opsi PII yang perlu dinyalakan/dimatikan di sini.
  Sentry.init({ dsn });
  active = {
    captureMessage: (message: string) => {
      void import('@sentry/react').then((mod) => mod.captureMessage(message));
    },
  };
}
